export default __webpack_public_path__ + "static/media/qi.842d787d.png";